import type { IconName } from '@/assets/icons/icons';

import type { MeetingProvider } from './meetings.types';

export const MEETING_PROVIDER_ICON: Record<MeetingProvider, IconName> = {
  hangoutsMeet: 'googleMeet',
  zoomMeeting: 'zoom',
  teamsForBusiness: 'microsoftTeams',
  slackHuddle: 'slack',
  webexMeeting: 'webex',
  wherebyMeeting: 'whereby',
  gotoMeeting: 'goToMeeting',
};
